/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {FormlyTemplateFieldType as Éµa} from './template.type';